module.exports = __webpack_public_path__ + "img/2.1f354100.png";